module.exports = __webpack_public_path__ + "static/media/ico_stickercontest_ig.c6e7d56b.png";